import { webApiBuildUrl } from '@api/utils'
import { fetchApi } from 'src/shared/lib/response-worker/model'
import { IBaseCatalogQuery } from 'src/shared/contract/type'
import { Group, IGroup } from '@entities/groups/contract'
import { Array } from 'runtypes'

export interface IRequestGroupSearch extends IBaseCatalogQuery {
    term: string
}

export function allGroupsUrl() {
    return webApiBuildUrl('api/catalog/main-groups')
}

export function searchGroupsUrl(cityId: number, term: string) {
    return webApiBuildUrl(`api/catalog/groups/search/${cityId}?q=${encodeURIComponent(term)}`)
}

export async function searchGroups({ term, shipment, ctx }: IRequestGroupSearch) {
    const response = await fetchApi.get<IGroup[]>(searchGroupsUrl(shipment.cityId, term.trim()), shipment, ctx)

    return Array(Group).check(response.data)
}
